import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HighlightSemicolonPipe } from './highlight-semicolon.pipe';

@NgModule({
  declarations: [HighlightSemicolonPipe],
  imports: [CommonModule],
  exports: [HighlightSemicolonPipe]
})
export class HighlightSemicolonPipeModule { }
